import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { PasswordStrengthValidatorComponent } from '../../../../common/password-strength-validator/password-strength-validator.component';
import { ToasterService } from '../../../../common/toaster/toaster.service';
import { AuthenticationService } from '../../../../domain/services/auth/authentication.service';
import { passwordMatchValidator } from '../../../../utils/mustMatchValidators';
import { CreatePassword } from '../../../../domain/models/createNewPassword';

@Component({
  selector: 'app-set-new-password',
  standalone: true,
 imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatButtonModule,
    PasswordStrengthValidatorComponent,
    RouterLink
  ],
  templateUrl: './set-new-password.component.html',
  styleUrl: './set-new-password.component.css'
})
export class SetNewPasswordComponent implements OnInit {
 hide = true;
  hideC = true;
  strongPassword = false;
  working = false;
  signupForm = new FormGroup({
    password: new FormControl('', [
      Validators.minLength(8),
      Validators.required,
    ]),
    confirmPassword: new FormControl('', [
      Validators.minLength(8),
      Validators.required,
    ]),
  }, { validators: passwordMatchValidator('password', 'confirmPassword') });
  private email: string | undefined;
  private token: string | undefined;
  constructor(private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly toasterService: ToasterService,
  private readonly route: ActivatedRoute) {
  }
ngOnInit(): void { 
  this.route.queryParams.subscribe(params => {
      this.email = decodeURIComponent(params['email']??'');
      this.token = params['token']??'';
      // use id as needed
    });
  }

  onPasswordStrengthChanged(event: boolean) {
    this.strongPassword = event;
  }

  createPassword() {
    const newPassword = this.f.password.value;
    if (newPassword) {
      let model : CreatePassword = {
        email: this.email ??'',
        password: this.signupForm.get('password')?.value ??'',
        token: this.token ??''
      };
      this.authService.setNewPassword(model).subscribe(value => {
        this.toasterService.show('success', 'Password was changed successfully', 'Your password was updated');
        this.router.navigate(['auth/login']);
      }, error => {
        this.toasterService.show('error', 'Password change failed', 'An error occurred while changing your password');
      })
    }
  }
   get f() {
    return this.signupForm.controls;
  }

  get passwordMismatch() {
    let confirmPassword = this.signupForm.get('confirmPassword')?.value ?? '';
    return this.signupForm.hasError('passwordMismatch') && (confirmPassword.length > 0);
  }

}
